exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".loading-text[data-v-2a7a6eb9] {\n  background-size: 200% auto;\n  animation: slide-data-v-2a7a6eb9 1.5s linear infinite;\n  will-change: background-position;\n}\n@keyframes slide-data-v-2a7a6eb9 {\nto {\n    background-position: -200% center;\n}\n}\n", ""]);

